// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FilterManager_separator_3QUeu::before,\n.FilterManager_separator_3QUeu::after {\n  content: \"\";\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  border-bottom: 1px solid #aab7b1;\n}\n.FilterManager_separator_3QUeu::before {\n  margin-right: 1em;\n}\n.FilterManager_separator_3QUeu::after {\n  margin-left: 1em;\n}", ""]);
// Exports
exports.locals = {
	"separator": "FilterManager_separator_3QUeu"
};
module.exports = exports;
